define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def",
    "csi/def/Field",
    "csi/state/rootStore",
    "Workflow/DateForm",
    "./CFCAAgent",
    "./main"
], function(declare,lang,def,Field,{ sessionStore },Widget,CFCAAgent,CFCA) {

    var CFCA_MESSAGE = "CFCAMessage";
    var CFCA_DIGITAL_SIGNATURE = "CFCADigitalSignature";

    var SELECT_CFCA_DIGITAL_CERTIFICATE = "SelectCFCADigitalCertificate";

    return declare(Widget, {

        _resolveView: function() {
            // add CFCA fields only if the user has a digital certificate
            // and WorkflowStep has CFCADigitalSignatureRequired set to true
            const stepResponseNode = this.getFormNode();
            const workflowStepNode = this.getCache().getPathNode(stepResponseNode, "Child:__Parent__/Child:WorkflowStep", true);

            const user = sessionStore.currentUser;
            if (user.CFCADigitalCertificate && workflowStepNode && workflowStepNode.CFCADigitalSignatureRequired) {
                this.insertField(lang.mixin(new Field(), {
                    m_id: CFCA_MESSAGE
                }));

                this.insertField(lang.mixin(new Field(), {
                    m_id: CFCA_DIGITAL_SIGNATURE,
                    m_bRequired: true,
                    m_onDraw: "onDrawCFCADigitalSignature"
                }));

                // add action to popup selection of certificate
                this.defView._addViewAction(SELECT_CFCA_DIGITAL_CERTIFICATE, {
                    m_typeControl: def.ACTION_BUTTON,
                    m_onAction: lang.hitch(this, "_onSelectCFCADigitalCertificate")
                });
            }

            this.inherited(arguments);
        },

        onDrawCFCADigitalSignature: function() {
            CFCA.drawSelectDigitalCertificateButton(this, CFCA_DIGITAL_SIGNATURE, SELECT_CFCA_DIGITAL_CERTIFICATE);
        },

        _onSelectCFCADigitalCertificate: function() {
            var fieldSignature = this.defView.getField(CFCA_DIGITAL_SIGNATURE);
            var cfcaMessage = this.getFieldValue(CFCA_MESSAGE);
            try {
                var signature = CFCAAgent.selectCertificateAndSignMessage(cfcaMessage);

                this.setFieldValue(fieldSignature, signature);
                this.setFieldStatus(fieldSignature, true);
                this.resetError();
            } catch (ex) {
                this.setFieldStatus(fieldSignature, false, ex.message);
                this._setErrorField(fieldSignature);
            }
        }
    });
});